import {isBiologicsEnabled} from 'antibodies/util/biologicsCapability';
import BenchlingConfig from 'BenchlingConfig';

/** Mirrors is_domain_sequence_annotation_enabled in annotate_domain_sequences_access.py. */
export default function isDomainSequenceAnnotationEnabled(): boolean {
  // ANTIBODY_ENABLE_DOMAIN_SEQUENCE_ANNOTATION is deprecated - use PROTEIN_ENABLE_DOMAIN_SEQUENCE_ANNOTATION.
  return (
    isBiologicsEnabled() &&
    (BenchlingConfig.PROTEIN_ENABLE_DOMAIN_SEQUENCE_ANNOTATION ||
      BenchlingConfig.ANTIBODY_ENABLE_DOMAIN_SEQUENCE_ANNOTATION)
  );
}
